import { ReactComponent as IconAddCircle } from "../../assets/icons/icon_add_circle.svg";
import { ReactComponent as IconEdit } from "../../assets/icons/icon_edit.svg";
import { ReactComponent as IconMore } from "../../assets/icons/icon_more.svg";
import { ReactComponent as IconDelete } from "../../assets/icons/icon_delete.svg";
import { ReactComponent as IconQr } from "../../assets/icons/qr.svg";
import IconBack from "../../assets/icons/icon_back.svg";
import Input from "../input";
import { Link } from "react-router-dom";

const CardContainer = (props) => {
  return (
    <div className="container">
      <div className="title-container">
        <img
          onClick={() => {
            window.history.back();
          }}
          alt="icon back"
          src={IconBack}
          style={{
            marginRight: "12px",
            display: props.isBack ? "block" : "none",
            cursor: "pointer",
          }}
        />
        {props.title}
      </div>
      <div style={{ display: props.isHeader ? "block" : "none" }}>
        <div className="table-header">
          <div className="toolbar-left">
            <div style={{ display: props.addShow ? "block" : "none" }}>
              <Link to={props.addClick} className="toolbar-button-default">
                {/* <img src={IconAddCircle} className="icon" /> */}
                <IconAddCircle className="icon" />
                <div className="toolbar-name">Add</div>
              </Link>
            </div>
            <div style={{ display: props.editShow ? "block" : "none" }}>
              <div onClick={props.editClick} className="toolbar-button-default">
                {/* <img src={IconEdit} className="icon" /> */}
                <IconEdit className="icon" />
                <div className="toolbar-name">Edit</div>
              </div>
            </div>
            <div style={{ display: props.detailShow ? "block" : "none" }}>
              <div
                onClick={props.detailClick}
                className="toolbar-button-default"
              >
                {/* <img src={IconMore} className="icon" /> */}
                <IconMore className="icon" />
                <div className="toolbar-name">Detail</div>
              </div>
            </div>
            <div style={{ display: props.qrShow ? "block" : "none" }}>
              <div className="toolbar-button-default" onClick={props.qrClick}>
                {/* <img src={IconDelete} className="icon" /> */}
                <IconQr className="icon" />
                <div className="toolbar-name">Generate QR</div>
              </div>
            </div>
            <div style={{ display: props.deleteShow ? "block" : "none" }}>
              <div
                className="toolbar-button-danger"
                onClick={props.deleteClick}
              >
                {/* <img src={IconDelete} className="icon" /> */}
                <IconDelete className="icon" />
                <div className="toolbar-name">Delete</div>
              </div>
            </div>
          </div>
          <div className="toolbar-right">
            <Input
              placeholder={props.searchPlaceholder || "Search"}
              id="search"
              onChange={(e) => props.onSearchChange(e)}
              type="search"
              className="form-search"
            />
          </div>
        </div>
      </div>
      {/* <div style={{ backgroundColor: "red" }}> */}
      {props.children}
      {/* </div> */}
    </div>
  );
};
export default CardContainer;
